import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Button from '../Button';
import EventShape from '../types/eventShape';
import Link from '../Link';
import TranslationProvider from '../../providers/TranslationProvider';
import Icon from '../Icon';
import calendarSVG from '../../svg/icons/ic_calendar-solid_20x20.svg';
import markerSVG from '../../svg/icons/map-marker.svg';
import videoSVG from '../../svg/icons/video.svg';
import {
  isInFuture,
} from '../../utils/resyCoreUtils';
import { redirectToSanitizedUrl } from '../../utils/sanitizeTargetUrl';

import './EventDetailsSummary.scss';

const EventDetailsSummary = ({
  context,
  locationSlug,
  neighborhood,
  showBookNowBtn,
  slideContent,
  venueSlug,
  event: {
    date,
    description,
    isOnline,
    time,
    title,
    venue,
    generalSaleDate,
  } = {},
}) => {
  const handleClick = () => {
    if (context === 'widget') {
      redirectToSanitizedUrl(`#/cities/${locationSlug}/venues/${venueSlug}`);
    } else {
      redirectToSanitizedUrl(`/cities/${locationSlug}/venues/${venueSlug}${window.location.search}`);
    }
  };

  const renderDescription = () => {
    if (!isInFuture(generalSaleDate)) {
      return (
        <div className="EventDetailsSummary__desc">
          {description}
        </div>
      );
    }

    return null;
  };

  const renderBookNowBtn = () => (
    <div className="EventDetailsSummary__book-now">
      <TranslationProvider translationKey="book_now">
        <Button
          onClick={() => {
            /* istanbul ignore next */
            const eventbooking = document.querySelector('.EventBooking');
            /* istanbul ignore next */
            if (eventbooking) eventbooking.scrollIntoView();
          }}
        >
          Book Now
        </Button>
      </TranslationProvider>
    </div>
  );
  return (
    <div className={`EventDetailsSummary ${slideContent?.length > 0 ? '' : 'no-image'}`}>
      <div className="EventDetailsSummary__label">
        <Link as="span" onClick={handleClick}>{venue}</Link>
      </div>
      <h1 className="EventDetailsSummary__title weight--bold">
        {title}
      </h1>
      <div className="EventDetailsSummary__datetime weight--bold">
        <Icon component={calendarSVG} iconClass="calendar" />
        {moment(`${date} ${time}`).format('LLLL')}
      </div>
      <div className="EventDetailsSummary__location">
        {isOnline
          ? (
            <>
              <Icon component={videoSVG} iconClass="video" />
              <TranslationProvider translationKey="virtual">
                <span>Virtual</span>
              </TranslationProvider>
            </>
          )
          : (
            <>
              <Icon component={markerSVG} iconClass="mapmarker" />
              {neighborhood}
            </>
          )}
      </div>
      {!showBookNowBtn ? renderDescription() : renderBookNowBtn()}
    </div>
  );
};

EventDetailsSummary.propTypes = {
  context: PropTypes.oneOf(['widget', 'consumer']),
  event: EventShape.isRequired,
  locationSlug: PropTypes.string.isRequired,
  neighborhood: PropTypes.string.isRequired,
  showBookNowBtn: PropTypes.bool,
  slideContent: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  venueSlug: PropTypes.string.isRequired,
};

EventDetailsSummary.defaultProps = {
  context: 'consumer',
  showBookNowBtn: false,
};

EventDetailsSummary.displayName = 'EventDetailsSummary';
export default EventDetailsSummary;
